// extracted by mini-css-extract-plugin
module.exports = {"modal":"_34akc","modalInner":"_10xAS","modalHeader":"_2NrsN","headerTitle":"_1hiAn","button":"_2rUoC","closeButton":"_1PLCa"};